import React from "react";
import { getAllActivePublications } from "@plugins/gatsby-source-paligo/src/config";
import { PublicationsConfigEntry } from "@plugins/gatsby-source-paligo/src/types";
import { box } from "@singlestore/fusion/components/layout";
import { H2 } from "@singlestore/fusion/components/typography";

import { Link } from "components/Link/Link";

import { DocumentNodeType, ProductVersionNodeForNavType } from "types/types";

import "./InThisSection.scss";

const publications = getAllActivePublications();

type InThisSectionProps = {
    documentNode: DocumentNodeType;
    productVersionNode: ProductVersionNodeForNavType;
};

export function InThisSection({
    documentNode,
    productVersionNode,
}: InThisSectionProps) {
    const sortedSubpages = React.useMemo(
        () => documentNode.children?.sort((a, b) => a.position - b.position),
        [documentNode.children]
    );

    const publicationConfig = publications.find(
        ({ id }) => id === productVersionNode.productNode.paligoId
    ) as PublicationsConfigEntry;

    if (
        !sortedSubpages?.length ||
        publicationConfig?.hideChildrenInNavbar?.includes(documentNode.paligoId)
    ) {
        return null;
    }

    return (
        <section className={box({ mt: "4x" })}>
            <H2 variant="heading-2">In this section</H2>
            <ul className="in-this-section-list">
                {sortedSubpages.map((child) => (
                    <li key={child.id}>
                        <Link to={child.path} variant="body-3">
                            {child.name}
                        </Link>
                    </li>
                ))}
            </ul>
        </section>
    );
}
